import { LoaderFunction, redirect } from "react-router-dom";
import { api } from "src/api/services/api";
import { store } from "src/api/store";
import { Paths } from "src/constants/paths";
import { getSupabaseSession } from "src/supabase/supabaseClient";

export const getMeLoader: LoaderFunction = async () => {
  const session = await getSupabaseSession();

  if (session == null) {
    store.dispatch(api.util.resetApiState());
    return redirect(Paths.LOG_IN);
  }

  const { data, error } = await store.dispatch(api.endpoints.getMe.initiate());

  if (error != null) {
    if ("status" in error && error.status === 401) {
      store.dispatch(api.util.resetApiState());
      return redirect(Paths.LOG_IN);
    }

    throw error;
  }

  return data;
};
